
import { Component, Vue } from 'vue-property-decorator'
import LoginTab from '@/views/login/LoginTab.vue'
import Register from '@/views/login/Register.vue'
import ForgetPassword from '@/views/login/ForgetPassword.vue'
@Component({
  components: {
    LoginTab,
    Register,
    ForgetPassword,
  },
})
export default class Login extends Vue {
  type = this.$route.query.type === '0' ? 'register' : 'login'
  changeType(type: string) {
    console.log(
      '🚀 ~ file: Login.vue ~ line 24 ~ Login ~ changeType ~ type', 
      type
    )

    this.type = type
  }
}
